/**
 * @fileoverview Redirects to Formstack feedback form.
 * @author akothapall@gannett.com (Amarnath Kothapalli)
 *
 */

define('modules/feedback-opinionlabs/feedback-opinionlabs',[
    'jquery',
    'underscore',
    'utils',
    'pubsub',
    'third-party-apis/formstack',
    'baseview'
],
function(
    $,
    _,
    Utils,
    PubSub,
    Formstack,
    BaseView
) {

"use strict";

/**
 * View class.
 */
var FeedbackFormstack = BaseView.extend({

    // Events.
    events: {
        'click .fbol-link': 'loadFeedbackForm',
    },

    /**
     * Initialize the view.
     */
    initialize: function(options) {
        _.bindAll(this, 'loadFeedbackForm');
        this.$feedbacklink = $('.fbol-link').data("analytics");
        BaseView.prototype.initialize.call(this, options);
    },

    loadFeedbackForm: function(e) {
        PubSub.trigger('track', {
            label: this.$feedbacklink
        });
        Formstack.redirectToFeedbackForm(e);
    }

});


/**
 * Return view class.
 */
return FeedbackFormstack;

});

